import { useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { localesWithFlags } from '../../../../utils/constants/locales';

function AdminHeaderLocaleSwitch() {
  const { setCurrentLanguage, configInfo } = useContext(TranslationContext);

  return (
    <div className="flex gap-2">
      {localesWithFlags
        ?.filter(({ allowedCountries }) => allowedCountries.includes(configInfo?.countryCode))?.map(
          ({ code }) => (
            <button
              type="button"
              key={code}
              onClick={
                            () => setCurrentLanguage(code)
                        }
              className="bg-transparent border-none uppercase cursor-pointer"
            >
              {code}
            </button>
          ),
        )}
    </div>
  );
}

export default AdminHeaderLocaleSwitch;
